import React, { useEffect, useState } from 'react';

import {
	createAdminServiceBlocks,
	updateAdminServiceBlocks,
} from '../../api/admin';

import useModal from '../../hooks/useModal';
import useAsync from '../../hooks/useAsync';
import usePrevious from '../../hooks/usePrevious';

import {
	TemplateCreateable,
	TemplateEditor,
	TemplateField,
} from '../../components/Attributes/Attributes_old';
import { Button } from '../../components/Button';
import Modal from '../../components/Shell/Modal';

const MODAL_NAME = 'addContentBlock';

const BLOCK_TYPES = [
	{ label: 'Repair', value: 'repair' },
	{ label: 'Preventive Maintenance', value: 'pm' },
	{ label: 'Notes', value: 'notes' },
	{ label: 'Parts Replaced', value: 'parts' },
];

const AddNewContentBlockModal = () => {
	const { open: options, setClose } = useModal(MODAL_NAME);
	const [newBlockForm, setNewBlockForm] = useState({});

	const { execute: onCreateServiceBlock } = useAsync(createAdminServiceBlocks, {
		immediate: false,
	});

	const { execute: onUpdateServiceBlock } = useAsync(updateAdminServiceBlocks, {
		immediate: false,
	});

	const prevOptions = usePrevious(options);
	useEffect(() => {
		if (!options && prevOptions) {
			setNewBlockForm({});
		}
	}, [options]);

	useEffect(() => {
		if (options?.block?.id) {
			setNewBlockForm(options?.block);
		}
	}, [options?.block?.id]);

	return (
		<Modal
			title={
				options?.block?.id
					? `Update: ${options?.block?.name}`
					: 'Create a new block'
			}
			open={options}
			onClose={() => setClose()}
		>
			<div className="grid grid-cols-2 gap-y-4">
				<TemplateField
					name="Name"
					value={newBlockForm?.name}
					onChange={(index, name) => setNewBlockForm({ ...newBlockForm, name })}
					autoFocus
				/>
				<TemplateEditor
					name="Content"
					value={newBlockForm?.delta}
					onChange={(index, content, raw) => {
						setNewBlockForm({ ...newBlockForm, ...raw });
					}}
					quillClassName="h-64 mb-12"
				/>

				<TemplateCreateable
					name="Type"
					options={BLOCK_TYPES}
					onChange={(index, type, raw) => {
						setNewBlockForm({ ...newBlockForm, type });
					}}
					value={newBlockForm?.type}
				/>

				<div className="flex justify-end col-span-2">
					<Button
						onClick={() => {
							if (options?.block?.id) {
								onUpdateServiceBlock(newBlockForm, (payload) => setClose());
							} else {
								onCreateServiceBlock(
									{ ...newBlockForm, predefined: true },
									(payload) => setClose()
								);
							}
						}}
					>
						{options?.block?.id ? 'Update Block' : 'Create Block'}
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default AddNewContentBlockModal;
